import * as React from 'react';
import AccordionGroup from '@mui/joy/AccordionGroup';
import Accordion from '@mui/joy/Accordion';
import AccordionDetails from '@mui/joy/AccordionDetails';
import AccordionSummary, { accordionSummaryClasses } from '@mui/joy/AccordionSummary';
import { H6, Body3 } from '../../themes/typography';

const DateTimeAccordion = ({
    eventDateTitle = 'Event Date as title',
    eventTimeTitle = 'Event Time as title',
    children = 'Accordion Content',
    disabled = false // Use the disabled prop to disable the accordion when there is no slot available
}) => {
    return (
        <AccordionGroup
            variant="plain"
            transition="0.2s"
            sx={{
                width: '100%',
                borderRadius: '15px',
                background: 'linear-gradient(to top left, #0A1528, #1D3A6E)',
                margin: '0px',
                padding: '0px',
                overflow: 'hidden',
                [`& .${accordionSummaryClasses.button}`]: {
                    padding: '4px 8px'
                },
                '& .css-8ys8ik-JoyAccordionGroup-root': {
                    padding: '0'
                }
            }}
        >
            <Accordion disabled={disabled}>
                <AccordionSummary
                    sx={{
                        '& .css-1twr7re-JoyAccordionSummary-button:not(.Mui-selected, [aria-selected="true"]):hover':
                            {
                                background: 'transparent'
                            },
                        '& .css-1twr7re-JoyAccordionSummary-button': {
                            margin: '0px'
                        },
                        margin: '0px',
                        padding: '0px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0px'
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <H6 color="#F8A21E">{eventDateTitle}</H6>
                        <Body3>{eventTimeTitle}</Body3>
                    </div>
                </AccordionSummary>
                <AccordionDetails
                    sx={{
                        padding: '0px 8px 0px 8px'
                    }}
                >
                    {children}
                </AccordionDetails>
            </Accordion>
        </AccordionGroup>
    );
};

export default DateTimeAccordion;
